export default "__VITE_ASSET__SX4o7OKw__"